import { ShiftSwapsFieldGroupErrors, ShiftSwapsFieldGroupValue } from './types';

export default shiftSwapsFieldGroupValidator;

export function shiftSwapsFieldGroupValidator(values: ShiftSwapsFieldGroupValue) {
  const errors: ShiftSwapsFieldGroupErrors = {};

  return errors;
}
